// extracted by mini-css-extract-plugin
export var badge = "accesscard-module--badge--b6620";
export var cardContainer = "accesscard-module--cardContainer--3fc58";
export var flexWrapper = "accesscard-module--flexWrapper--43285";
export var infoSide = "accesscard-module--infoSide--c6264";
export var label = "accesscard-module--label--97344";
export var mapSide = "accesscard-module--mapSide--1a1be";
export var naviButton = "accesscard-module--naviButton--02a57";
export var parkingBox = "accesscard-module--parkingBox--a417a";
export var pointSection = "accesscard-module--pointSection--b927f";
export var roadList = "accesscard-module--roadList--87159";
export var section = "accesscard-module--section--d4142";
export var text = "accesscard-module--text--4af1e";